import { resourceAllocations } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveProjectResourceAllocationsRequestFailure(
      { uuid },
      { uuid: projectUuid },
    ) {
      const req = getState().find(
        ({ project, projectResource }) =>
          project.uuid === uuid && projectResource.uuid === projectUuid,
      );
      return req ? req.request.isFailure : false;
    },
    isRetrieveProjectResourceAllocationsRequestPending(
      { uuid },
      { uuid: projectUuid },
    ) {
      const req = getState().find(
        ({ project, projectResource }) =>
          project.uuid === uuid && projectResource.uuid === projectUuid,
      );
      return req ? req.request.isPending : false;
    },
    isRetrieveProjectResourceAllocationsRequestSuccess(
      { uuid },
      { uuid: projectUuid },
    ) {
      const req = getState().find(
        ({ project, projectResource }) =>
          project.uuid === uuid && projectResource.uuid === projectUuid,
      );
      return req ? req.request.isSuccessful : false;
    },
    isProjectResourceAllocationsDirty({ uuid }, { uuid: projectUuid }) {
      const req = getState().find(
        ({ project, projectResource }) =>
          project.uuid === uuid && projectResource.uuid === projectUuid,
      );
      return req ? req.isDirty : false;
    },
    getProjectResourceAllocations({ uuid }, { uuid: projectUuid }) {
      const req = getState().find(
        ({ project, projectResource }) =>
          project.uuid === uuid && projectResource.uuid === projectUuid,
      );

      return req ? req.resourceAllocations : resourceAllocations;
    },
  };
}

export { createSelector };
